<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12">
                <h3 class="mt-3 mb-1">ผู้ขอคำปรึกษา</h3>
              </b-col>

              <ValidationProvider
                name="ผู้ขอคำปรึกษา"
                v-slot="{ errors }"
              >
                <div class="container mb-3">
                  <b-button variant="primary" @click="personalModalClicked('')">
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>เพิ่มข้อมูล</span>
                  </b-button>
                </div>

                <span class="text-danger ml-2">{{ errors[0] }}</span>

                <input v-model="personal" type="hidden" />
                <div v-if="personal !== null" class="container">
                  <b-list-group flush>
                    <PersonDataDigital
                      :IsReadOnly="false"
                      :person="personal"
                      @handle-edit-personal="
                        personalModalClicked(personal.userId)
                      "
                    />
                  </b-list-group>
                </div>
              </ValidationProvider>

              <b-col cols="12">
                <h3 class="mt-3 mb-1">ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)</h3>
              </b-col>

              <b-col cols="12" class="">
                <b-form-group label="รหัสผู้ถูกตรวจสอบ">
                  <b-form-input
                    class="col-6"
                    v-model="consultData.compId"
                    readonly="readonly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <label for="compName"
                    >ชื่อผู้ถูกตรวจสอบ <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    name="ชื่อผู้ถูกตรวจสอบ"
                    v-slot="{ errors }"
                  >
                    <vue-autosuggest
                      :v-model="consultData.compName"
                      :value="consultData.compName"
                      :suggestions="filteredOptions"
                      :limit="limit"
                      :input-props="inputProps"
                      @selected="onSelected"
                      @input="onInputChange"
                      :get-suggestion-value="getSuggestionValue"
                    >
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item">{{
                          suggestion.item.label
                        }}</span>
                      </template>
                    </vue-autosuggest>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="ที่ตั้ง/ที่อยู่">
                  <CompanyAddress
                    v-if="address !== null && address !== undefined"
                    :address="address"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" class="">
                <b-form-group>
                  <label for="consultSubject"
                    >เรื่องให้คำปรึกษา/แนะนำ
                    <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="เรื่องให้คำปรึกษา/แนะนำ"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="consultSubject"
                      v-model="consultData.consultSubject"
                      placeholder="กรุณากรอก เรื่องให้คำปรึกษา/แนะนำ"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="">
                <b-form-group>
                  <label for="consultDetail"
                    >รายละเอียดเพิ่มเติม
                    <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="รายละเอียดเพิ่มเติม"
                    v-slot="{ errors }"
                  >
                    <b-form-textarea
                      v-model="consultData.consultDetail"
                      rows="5"
                    ></b-form-textarea>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <div
                v-for="value in consultDetail"
                :key="value.description"
                class="col-12"
              >
                <ValidationProvider
                  rules="checkRequired"
                  name="หมวดหมู่"
                  v-slot="{ errors }"
                >
                  <div class="mt-2">
                    <h4 class="">
                      {{ value.description }}
                    </h4>
                    <b-row>
                      <b-col
                        v-for="(box, index) in value.tmMasterList"
                        :key="index"
                        cols="4"
                        class="mt-1"
                      >
                        <b-form-checkbox
                          :key="index"
                          v-model="box.checked"
                          @change="checkboxChanged(box)"
                        >
                          {{ box.description }}
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-col cols="12">
                      <hr />
                    </b-col>
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <b-col cols="12">
                <h3>เอกสารและหลักฐาน</h3>
              </b-col>

              <b-row
                v-for="file in this.attachFiles"
                :key="file.attachId"
                class="col-12 m-1 col-md-6"
              >
                <b-col md="10">
                  <a
                    :href="file.filePath"
                    :download="file.fileName"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-arrow-down-circle"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="8 12 12 16 16 12" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                    </svg>
                    {{ file.fileName }}
                  </a>
                </b-col>
                <b-col md="2" class="d-flex justify-content-center">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="onAttachFileDelete(file.attachId)"
                  >
                    <feather-icon icon="Trash2Icon" size="24" />
                  </a>
                </b-col>
              </b-row>

              <b-col cols="12" md="6">
                <b-form-group>
                  <b-form-select v-model="selected" :options="attachTypes" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group>
                  <b-form-file
                    @change="onUploadFileChanged"
                    ref="file-input"
                    multiple
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12"></b-col>

              <b-col cols="12">
                <h3>ส่วนของเจ้าหน้าที่</h3>
              </b-col>

              <b-col cols="12" class="">
                <b-form-group>
                  <label for="comment">ความเห็นเจ้าหน้าที่</label>
                  <ValidationProvider
                    name="ความเห็นเจ้าหน้าที่"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="comment"
                      v-model="consultData.comment"
                      placeholder="กรุณากรอก ความเห็นเจ้าหน้าที่"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="">
                <b-form-group>
                  <label for="remark">หมายเหตุ</label>
                  <ValidationProvider name="หมายเหตุ" v-slot="{ errors }">
                    <b-form-textarea
                      v-model="consultData.remark"
                      rows="5"
                    ></b-form-textarea>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>
    <ModalDigitalId
      ref="modalDigitalIdComponent"
      :userId="currentUserIdModal"
      @handle-success="onModalDigitalIdSuccess"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BListGroup,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import { VueAutosuggest } from "vue-autosuggest";

import CompanyAddress from "../components/CompanyAddress.vue";

import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import PersonDataDigital from "../components/PersonDataDigital.vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as consultStore from "@/store/api/consult/index.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BListGroup,
    ValidationObserver,
    ValidationProvider,
    extend,
    VueSelect,
    CompanyAddress,
    VueAutosuggest,
    ModalDigitalId,
    PersonDataDigital,
  },
  data() {
    return {
      consultData: {
        isActive: true,
      },
      attachFiles: [],
      address: {},
      consultDetail: [],
      masterIdList: [],
      personal: null,
      attachTypes: [{ value: null, text: "ประเภทเอกสาร", disabled: true }],
      selected: 13,
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      modalMode: "",
      currentUserIdModal: "",
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      languages: lang.th,
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      complaintStore.GetInitComplaintTmMasterType([5, 6])
      .then(function(response) {
        _this.consultDetail = response.data.data;
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        //console.log('GET')
      });
    } else {
      const id = this.$route.query.id;
      this.getconsultById(id);
    }

    this.getFileType();

    extend("checkRequired", {
      validate(value) {
        return {
          required: true,
          valid: _this.tab3check(),
        };
      },
      message: "กรุณาเลือก{_field_} อย่างน้อย 1 หมวดหมู่",
      computesRequired: true,
    });
  },
  methods: {
    getconsultById(id) {
      const _this = this;

      consultStore
        .getById(id)
        .then((response) => {
          // _this.consultData = response.data.data
          _this.consultData = response.data.data.consultData;
          _this.attachFiles = response.data.data.attachFiles;
          _this.consultDetail = response.data.data.consultDetail;

          //console.log('_this.consultData.userId', _this.consultData.userId)
          if (_this.consultData.userId !== null) {
            _this.onModalDigitalIdSuccess(_this.consultData.userId);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.consultData.updateBy = userData.userId();

            const params = {
              consultData: _this.consultData,
              attachFiles: _this.attachFiles,
              consultDetail: _this.consultDetail,
              personal: _this.personal,
            };

            consultStore
              .updateItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "Consult",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "Consult" }).href, "_self");
    },
    onAgeRangeInput() {
      this.consultData.ageRangeId = this.consultData.ageRangeOption.value;
    },
    onOccupationInput() {
      this.consultData.occupationId = this.consultData.occupationOption.value;
    },
    onSelected(option) {
      const _this = this;

      this.consultData.compName = option.item.label;
      this.consultData.compId = option.item.value;
      console.log(option);
      // get company address detial
      companyStore
        .getAddressDetail(option.item.value)
        .then((response) => {
          _this.address = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onInputChange(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      companyStore
        .getByName(text)
        .then((response) => {
          console.log("response", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredCompany = response.data.data.slice(0, this.limit);
          _this.filteredOptions = [
            {
              data: filteredCompany,
            },
          ];

          console.log("_this", _this.filteredOptions);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSuggestionValue(suggestion) {
      console.log("suggestion item", suggestion.item);
      this.consultData.compId = suggestion.item.value;
      return suggestion.item.label;
    },
    selectOnInput() {
      console.log("on input");
      this.$forceUpdate();
    },
    checkboxChanged(obj) {
      const _this = this;
      if (obj.checked) {
        this.masterIdList.push(obj.masterId);
      } else {
        //uncheck
        this.masterIdList = this.masterIdList.filter((o) => {
          return o != obj.masterId;
        });

        //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

        var notInside = [];
        //get remove list
        this.consultDetail.forEach((o) => {
          if (obj.masterTypeId < o.masterTypeId) {
            o.tmMasterList.forEach((o2) => {
              notInside.push(o2.masterId);
            });
          }
        });

        //console.log("notInside:", notInside);
        this.masterIdList = this.masterIdList.filter((o) => {
          return !notInside.includes(o);
        });
        //end check
      }

      console.log("masterIdList:", this.masterIdList);

      var self = this;

      complaintStore
        .GetMasterTypeAll(this.masterIdList)
        .then(function(response) {
          console.log("response:", response);
          var dataList = response.data.data; //list รายการทั้งหมด
          //self.$refs.Step3Ref.refreshPage()

          //แสดงรายการ checkbox
          self.consultDetail.forEach((o) => {
            o.tmMasterList = dataList.filter((o2) => {
              return o2.masterTypeId == o.masterTypeId;
            });
          });

          //ใส่ค่า check true
          self.consultDetail.forEach((o) => {
            o.tmMasterList.forEach((o2) => {
              if (self.masterIdList.includes(o2.masterId)) {
                o2.checked = true;
              }
            });
          });
          _this.$forceUpdate();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {});
      //console.log("checkboxChangeRoot: ", obj);
    },
    personalModalClicked(id) {
      this.modalMode = "personal";
      this.currentUserIdModal = id;
      this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
    },
    onModalDigitalIdSuccess(id) {
      let _this = this;
      //console.log("this", this.personals, this.attorneys);
      // need to get user id to update to view
      const currentUserId = id;
      this.currentUserIdModal = "";

      userStore
        .getById(currentUserId)
        .then(function(response) {
          // handle success
          console.log("userStore.getById", response);
          const person = response.data.data;
          _this.personal = person;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].hide();
        });
    },
    tab3check() {
      var check = true;

      this.consultDetail.forEach((o) => {
        if (!o.tmMasterList) {
          //กรณี ประเภทร้องทุกข์ และ สาเหตุที่ต้องร้องทุกข์ ยังไม่ขึ้นบนหน้า front จะถือว่าไปต่อไม่ได้
          check = false;
        } else {
          //กรณีขึ้นครบแล้วต้องมีอย่างน้อย 1 check
          var checkList = o.tmMasterList.filter((o2) => {
            return o2.checked;
          });

          if (checkList.length == 0) {
            check = false;
          }
        }
      });

      console.log("check", check);
      return check;
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
  },
  onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>
